module.exports = __webpack_public_path__ + "img/12.397a3d5f.png";